<template>
  <modal-provider name="pay-part-modal"
                  ref="modalProvider"
                  class="pay-part-modal"
                  @before-open="disableScroll"
                  @before-close="enableScroll"
                  :width="570"
                  :title="$t('product-page__pay-part-modal-title')">
    <div class="pay-part-modal">
      <pay-part-modal-content></pay-part-modal-content>
    </div>
  </modal-provider>
</template>

<script>
import PayPartModalContent from '@/components/product/product-page/pay-part/PayPartModalContent.vue'

export default {
  name: 'PayPartModal',
  data () {
    return {
      touchStartY: 0,
      touchEndY: 0
    }
  },
  components: {
    PayPartModalContent
  },
  methods: {
    setTouchY (prop, evt) {
      this[prop] = evt.changedTouches[0].clientY
    },
    disableScroll () {
      // Get the current page scroll position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

      // if any scroll is attempted,
      // set this to the previous value
      window.onscroll = function () {
        window.scrollTo(scrollLeft, scrollTop)
      }
    },
    enableScroll () {
      window.onscroll = function () { }
    }
  },
  mounted () {
    this.$refs.modalProvider.$el.addEventListener('touchstart', (evt) => this.setTouchY('touchStartY', evt))
    this.$refs.modalProvider.$el.addEventListener('touchend', (evt) => this.setTouchY('touchEndY', evt))
  },
  destroyed () {
    this.$refs.modalProvider.$el.removeEventListener('touchstart', (evt) => this.setTouchY('touchStartY', evt))
    this.$refs.modalProvider.$el.removeEventListener('touchend', (evt) => this.setTouchY('touchEndY', evt))
  },
  watch: {
    touchEndY (val) {
      if (this.touchEndY > 0 && this.touchStartY > 0 && val - this.touchStartY >= 150) {
        this.touchEndY = 0
        this.touchStartY = 0
        this.$modal.hide('pay-part-modal')
      }
    }
  }
}
</script>
<style lang="sass">
.pay-part-modal
  .modal__title
    font-size: 24px !important
  +mmax($tablet)
    .modal__close
      width: 80px
      height: 5px
      left: 50%
      top: 10px
      transform: translateX(-50%)
      background-color: #333
      border-radius: 3px
      &:hover
        background-color: #333
      &:before, &:after
        display: none
    .modal__title
      font-size: 20px !important
      text-align: left
    .modal-heading
      padding: 25px 30px 10px !important
      text-align: center
    .v--modal-box
      max-width: 100%
      width: 100% !important
      margin-top: auto
      margin-bottom: -10px
      border-top-left-radius: 30px
      border-top-right-radius: 30px
</style>
